import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "../../constants";
import { removeSpacesFromCode } from "../formatters/registrationCode";
export const getIsDeviceHasCorrectLength = ({ deviceCode, allowedLengths = DEFAULT_ALLOWED_DEVICE_CODE_LENGTH, }) => {
    const formattedCode = removeSpacesFromCode(deviceCode);
    return allowedLengths.includes(formattedCode.length);
};
//# sourceMappingURL=deviceRegistration.js.map